var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOpenChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6079 9.5C19.6079 14.1944 15.8023 18 11.1079 18C10.0311 18 9.00111 17.7998 8.05306 17.4345C7.87972 17.3678 7.79305 17.3344 7.72413 17.3185C7.65635 17.3029 7.60728 17.2963 7.53776 17.2937C7.46709 17.291 7.38955 17.299 7.23447 17.315L2.11344 17.8444C1.6252 17.8948 1.38108 17.9201 1.23708 17.8322C1.11165 17.7557 1.02622 17.6279 1.00348 17.4828C0.977371 17.3161 1.09403 17.1002 1.32734 16.6684L2.96299 13.6408C3.0977 13.3915 3.16505 13.2668 3.19555 13.1469C3.22568 13.0286 3.23297 12.9432 3.22333 12.8214C3.21357 12.6981 3.15947 12.5376 3.05127 12.2166C2.76375 11.3636 2.6079 10.45 2.6079 9.5C2.6079 4.80558 6.41348 1 11.1079 1C15.8023 1 19.6079 4.80558 19.6079 9.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOpenChat);
export default __webpack_public_path__ + "static/media/account_open_chat.a05e0150d82a4440fff6d2a79c2705e4.svg";
export { ForwardRef as ReactComponent };